/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Program } from "./Program";
export const ProgramResponse = core.serialization.object({
    data: Program,
});
